module.exports = __webpack_public_path__ + "static/media/activity.9d4b53b7.svg";